import * as React from 'react'
import MuiAvatar from '@mui/material/Avatar'
import { AvatarProps } from '@mui/material'

const Avatar = (props: AvatarProps) => {
    return <MuiAvatar {...props}>{props.children}</MuiAvatar>
}

export default Avatar
